'use client';

import type {ComponentProps, FC} from 'react';
import {useRef, useState} from 'react';
import clsx from 'clsx';

import {Dropdown} from './Dropdown';
import type {NavigationType} from './Navbar';
import {NavLink} from './NavLink';

type Props = {
	navigation: NavigationType;
} & ComponentProps<'div'>;

export const DesktopNav: FC<Props> = ({navigation, className, ...rest}) => {
	const [activeDropdownId, setActiveDropdownId] = useState<string | null>(null);

	const navRef = useRef<HTMLDivElement>(null);

	return (
		<div ref={navRef} className={clsx('z-50', className)} {...rest}>
			<ul className="flex items-center gap-6">
				{navigation.map((item) => {
					if (item.type === 'dropdown' && item.links && item.links.length > 0) {
						return (
							<Dropdown
								dropdown={item}
								key={item._key}
								id={item._key}
								navRef={navRef}
								activeDropdownId={activeDropdownId}
								setActiveDropdownId={setActiveDropdownId}
							/>
						);
					}

					if (item.type === 'navlink') {
						return (
							<li key={item._key}>
								<NavLink link={item} />
							</li>
						);
					}
				})}
			</ul>
		</div>
	);
};
